import { configSelector } from './redux/app/selectors.js';
import { store } from './redux/store.js';
import { router } from './router.js';
import { downloads } from './utils/downloads.js';
import { getDefaultParam } from './utils/getDefaultParam.js';
import { pushNotifications } from './utils/push/pushNotifications.js';
import { radHttp } from './utils/rad-http/radHttp.js';
import { setStore } from './utils/redux/store/setStore.js';
import { setRouter } from './utils/router/setRouter.js';

setStore(store);
setRouter(router);

router.resolve();

radHttp.getDefaultParam = getDefaultParam;
radHttp.defaultResponseHandler = ({ response }) => {
  if (response?.status !== 401) return;

  window.location.href = `${configSelector().loginUrl}?ReturnUrl=${encodeURIComponent(window.location.href)}`;
};

pushNotifications.connect();
downloads.enable();

// Must be this style import or else getDefaultParam won't be set in time.
import('./components/rad-app.js');